export const AppName = "CodeSpark";
export const AdminEmail = "shanmugamsanthosh22@gmail.com";
export const AdminUSerid = [
  "go7mA8nEwvOjH08Tl7ghMcSMmjo2",
  "JNoJYZ0ltfdfGWTySWHS1qZbyjt2",
];
export const API_KEY = "AIzaSyDNbbMs2tWXNuSiOEDnu8vCJjyDGQHHFX8";
